import { z } from 'zod';
export const scheduleRefSchema = z.object({
    direction: z.enum(['income', 'expense']),
    displayId: z.string(),
    name: z.string(),
    inflationExempt: z.boolean().default(false),
    runRate: z.boolean().default(false),
});
export function scheduleInflationOf(ref) {
    if (ref.inflationExempt === true)
        return 'fixed';
    if (ref.direction === 'expense' && ref.runRate === true)
        return 'already_inflated';
    return 'budget_cpi';
}
export function normalizeCategoryText(text) {
    return text.trim().replace(/\s+/g, ' ').toLowerCase();
}
export const taxonomyLineId = (taxonomyId) => `taxonomy:${taxonomyId}`;
export function taxonomyIdOfLine(lineId) {
    const match = /^taxonomy:(\d+)$/.exec(lineId);
    return match ? Number(match[1]) : undefined;
}
export function lineKeyId(key) {
    switch (key.kind) {
        case 'taxonomy':
            return taxonomyLineId(key.taxonomyId);
        case 'unmapped':
            return `unmapped:${key.type}:${normalizeCategoryText(key.categoryText)}`;
        case 'uncategorized':
            return `uncategorized:${key.type}`;
        default: {
            const _exhaustive = key;
            throw new Error(`Unhandled line key: ${JSON.stringify(_exhaustive)}`);
        }
    }
}
//# sourceMappingURL=projection.js.map